import {
  CultivationEventCreateWithoutCultivationInput,
  CultivationEventType,
  CultivationsForCrop_cultivations,
  CultivationsForDate_cultivations,
  CultivationsForPlot_cultivations,
  PlantOrSeed
} from "../../../__generated__/types";
import {
  calculateHarvestWindow,
  calculateSowingOrPlantingWindow
} from "../../../pages/21/Planning21/planning21-mutations";
import {compact} from "lodash";
import {asIso8601, momentFromIso8601} from "../date.utils";
import moment from "moment";

export const cultivation_bestFitName = (crop: { name: string }, variety: { alternativeCropName: string | null }) => {
  return variety.alternativeCropName ? variety.alternativeCropName : crop.name;
};

export const humanReadableCultivationType = (plantOrSeed: PlantOrSeed) =>
  plantOrSeed === PlantOrSeed.SEED ? 'Rechtstreeks zaaien' : 'Planten';


export const createCultivationEvents = (cultivation: CultivationsForCrop_cultivations | CultivationsForDate_cultivations | CultivationsForPlot_cultivations) => {
  const sowingOrPlantingWindow = calculateSowingOrPlantingWindow(cultivation.cropTiming, cultivation.startDate);
  const harvestWindow = calculateHarvestWindow(cultivation.cropTiming, cultivation.startDate, cultivation.harvestEndDate);

  const seedingEvent = (cultivation.events || [])
    .find(event => event.type === CultivationEventType.SEED);

  let events: CultivationEventCreateWithoutCultivationInput[] = compact([
    {
      date: asIso8601(moment(sowingOrPlantingWindow.firstDay).subtract(1, 'week')),
      type: CultivationEventType.BED_PREP,
    },
    {
      date: asIso8601(sowingOrPlantingWindow.firstDay),
      type: cultivation.cropTiming.type === PlantOrSeed.SEED ? CultivationEventType.SEED : CultivationEventType.PLANT,
    },
    {
      date: asIso8601(harvestWindow.firstDay),
      type: CultivationEventType.HARVEST,
    },
    {
      date: asIso8601(harvestWindow.lastDay),
      type: CultivationEventType.HARVEST_END,
    },
    !cultivation.transplant && cultivation.cropTiming.type === PlantOrSeed.PLANT ? {
      date: asIso8601(moment(sowingOrPlantingWindow.firstDay).subtract((cultivation.crop.daysToTransplant || 30), 'days')),
      type: CultivationEventType.PRESEED,
    } : undefined,
  ]);


  const flameWeedEvents = ['Busselwortel', 'Bewaarwortel'].includes(cultivation.crop.name) ? [5, 10].map(offset => {
    debugger;
    const seedingDate = seedingEvent?.executionDate || seedingEvent?.date;
    const flameweedDay = (
        seedingDate
          ? momentFromIso8601(seedingDate)
          : sowingOrPlantingWindow.firstDay.clone()
      )
      .add(offset, 'day');
    return {
      date: asIso8601(flameweedDay),
      type: CultivationEventType.FLAMEWEED,
    };
  }) : [];
  return [...events, ...flameWeedEvents];
};
